import React, { useState } from "react";
import { useRouter } from "next/router";
const Line = () => {
  const router = useRouter();

  return (
    <div
      className={`sm:block hidden ${
        router.locale == "ar" ? "-scale-x-100" : ""
      } `}
    >
      <svg
        width="2014"
        height="376"
        viewBox="0 0 2014 367"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M1992.5 155C1871.5 53.5004 1725.45 13.4737 1557.73 41.5026C1368.3 73.1604 1230.51 255.39 942.928 319.038C649.628 383.95 429.905 211.289 1.5153 228.319"
          stroke="url(#paint0_linear_3939_5500)"
          className="  stroke-[40px] xlg:stroke-[55px]"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3939_5500"
            x1="802.943"
            y1="376.159"
            x2="891.626"
            y2="-81.1551"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#2EBBFF" />
            <stop offset="0.5112" stop-color="#FE17FF" />
            <stop offset="1" stop-color="#6232EA" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default Line;
